export type LandingVisit = "first" | "returning";

export interface LandingChoice {
  visit: LandingVisit;
  /** Secondary action that opens the originations hub. */
  showHistory: boolean;
  /** Whether the compose action can be used. */
  canCompose: boolean;
}

/**
 * First visit keeps a single start button. A returning sender sees history
 * plus compose; compose stays visible but disabled when the account cannot originate.
 */
export function landingChoice(
  originationCount: number,
  canOriginate: boolean
): LandingChoice {
  if (originationCount > 0) {
    return {
      visit: "returning",
      showHistory: true,
      canCompose: canOriginate,
    };
  }

  return {
    visit: "first",
    showHistory: false,
    canCompose: canOriginate,
  };
}
